import { render, staticRenderFns } from "./addStaffStep.vue?vue&type=template&id=5f3250e8&scoped=true"
import script from "./addStaffStep.vue?vue&type=script&lang=js"
export * from "./addStaffStep.vue?vue&type=script&lang=js"
import style0 from "./addStaffStep.vue?vue&type=style&index=0&id=5f3250e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3250e8",
  null
  
)

export default component.exports